import styled from "styled-components";

const GameImage = styled.img`
  border-radius: 10px;
  object-fit: cover;
  width: 100%;
`;

export default GameImage;
